import ProgramTypeAhead from "../components/ProgramTypeAhead";
import ValidationError from "../components/ValidationError";
import { createApp } from "vue";
import BootstrapVueNext from "bootstrap-vue-next";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

if (document.getElementById("program-registration-page")) {
  const app = createApp({
    components: {
      ProgramTypeAhead,
      ValidationError,
    },
    data() {
      return {
        user: {
          phone_number: null,
          role_in_program: null,
        },
        program: {
          // name: null,
          street: null,
          city: null,
          state: null,
          zip: null,
          county: null,
          name: null,
          meals_provided: [],
          offered_services: [],
          associated_utilities: [],
          meals_provided_by: [],
          max_adults: null,
          current_adults_num: null,
        },
        consultant: null,
        counties: [],
        states: [],
        errors: {},
        programTypes: [],
        ownershipStructures: [
          "Private non-profit",
          "Private for-profit",
          "Publicly traded company or limited liability company",
          "Government (federal, state, county, or local)",
          "Unknown",
        ],
        page: 1,
        registrationCode: null,
        validating: false,
      };
    },
    computed: {
      stateCounties: function () {
        try {
          if (this.states.length && this.program.state) {
            return this.states.find(
              function (state) {
                return state.id === this.program.state;
              }.bind(this)
            ).counties;
          }
        } catch (err) {
          throw new Error("program_register::stateCounties: " + err.message);
        }
        return [];
      },
      hasErrors: function () {
        try {
          return Object.keys(this.errors).length > 0;
        } catch (err) {
          throw new Error("program_register::hasErrors: " + err.message);
        }
      },
    },
    methods: {
      setProgramVars(program) {
        Vue.set(this.program, "city", program.city);
        Vue.set(this.program, "zip", program.zip);
        Vue.set(this.program, "state", program.state_id);
        Vue.set(this.program, "county", program.county_id);
      },
      getProgramTypes() {
        axios("/api/program-types")
          .then(
            function (response) {
              this.programTypes = response.data.data;
            }.bind(this)
          )
          .catch(function (error) {
            console.error(error);
          });
      },
      getStates() {
        axios("/api/states")
          .then(
            function (response) {
              this.states = response.data;
            }.bind(this)
          )
          .catch(function (error) {
            console.error(error);
          });
      },
      setError(error) {
        this.errors[error] = true;
        Vue.set(this.errors, error, true);
      },
      clearErrors() {
        this.errors = {};
      },
      setPage(idx) {
        if (idx < 1) {
          this.page = 1;
        } else if (idx > 3) {
          this.page = 3;
        } else {
          this.page = idx;
        }
        window.location.href = "#page=" + this.page;
      },
      hasPreviousPage() {
        return this.page > 1;
      },
      hasNextPage() {
        return this.page < 2;
      },
      setRegistrationCode() {
        var queryDict = {};
        location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            queryDict[item.split("=")[0]] = item.split("=")[1];
          });
        if (queryDict.hasOwnProperty("registration_code")) {
          this.user.registration_code = queryDict.registration_code;
        }
      },
      submitForm() {
        document.getElementById("program-reg-form").submit();
      },
      validatePage() {
        this.clearErrors();
        this.validating = true;

        let allData = Object.assign({}, this.user, this.program);

        window.axios
          .post("/api/programs/registration/page" + this.page, allData)
          .then((response) => {
            if (this.hasNextPage()) {
              this.setPage(this.page + 1);
              return response;
            }
            this.submitForm();
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
            window.location.href = "#registration";
            return error;
          })
          .then(() => {
            this.validating = false;
          });
      },
      validateRegistrationCode() {
        if (this.user.registration_code) {
          axios
            .get("/api/code/" + this.user.registration_code)
            .then(() => {
              this.verifyEmail();
            })
            .catch((error) => {
              this.setError("invalid_registration_code");
              // this.verifyEmail()
            });
        } else {
          // this.verifyEmail()
        }
      },
      verifyEmail() {
        if (this.user.email && this.user.email == this.user.emailConfirmation) {
          axios
            .get("/api/email-not-in-use", { email: this.user.email })
            .then(
              function (response) {
                if (response.data > 0) {
                  this.setError("emailInUse");
                  return false;
                }
              }.bind(this)
            )
            .catch(
              function (error) {
                this.setError("emailInUse");
              }.bind(this)
            );
        }
      },
      checkRegistrationCode() {
        this.consultant = null;
        this.registrationCode = null;
        if (this.user.registration_code) {
          axios
            .get("/api/code/" + this.user.registration_code)
            .then((response) => {
              delete this.errors.registration_code;
              this.registrationCode = response.data;
              if (response.data.consultant) {
                this.consultant = response.data.consultant;
              }
            })
            .catch(
              function (error) {
                window.Vue.set(this.errors, "registration_code", [
                  "This registration code is invalid",
                ]);
              }.bind(this)
            );
        } else {
          this.setError("registration_code");
        }
      },
    },
    mounted: function () {
      this.getStates();
      this.getProgramTypes();
      this.setRegistrationCode();
    },
  });

  app.use(BootstrapVueNext);
  app.mount("#program-registration-page");
}
